import { FilterOperator, FilterOptionsType, SortDirection } from "./generic";

export class ISAPI {
    constructor(
        public filters: ISFilterAPI[],
        public pagination: ISPagination = { pageSize: 10, page: 1 }
    ) { }
}

export class ISFilterAPI {
    constructor(
        public identifier: string,
        public value: any,
        public type: string = FilterOptionsType.text, 
        public operator: string = FilterOperator.contains,
        public orderType: SortDirection = SortDirection.none,
        public navigation?: string,
        public alternativeIdentifier?: string,
        public searchField?: string
    ) { }
}

export class ISPagination {
    constructor(
        public pageSize: number = 10,
        public page: number = 1
    ) { }
}

export class MVFilter {
  constructor(
    public columnIdentifier: string,
    public value: string,
    public dataType: string = FilterOptionsType.text,
    public operator: string = FilterOperator.contains,
    public columnNavigation?: string
  ) {}
}

export class MVOrdering {
  constructor(
    public columnIdentifier: string,
    public direction: string = SortDirection.asc,
    public columnNavigation?: string
  ) {}
}

export class MVPagination {
  constructor(
    public page: number = 1,
    public pageSize: number = 10
  ) {}
}

export class MVListingConfigs {
  constructor(
    public filters: MVFilter[],
    public ordering: MVOrdering | null,
    public pagination: MVPagination
  ) {}
}
